import * as React from 'react';
import './index.css';
import { RichText } from '@wmfe/mach-pro-components-react';
import { highlightListForText } from '@/common/Highlight';
import ContentSuperItem from '../itemSuperCard/itemSuperCard';

/**
 * 商卡优惠组件
 *
 * {
    "bgColor": "#999999",
    "orderBgColor": "#999999",
    "orderTagIcon": "http://img-ap-hongkong.mykeeta.net/picturesupload/52ca3dd1a7bae9094b6417ae970098a33994.png",
    "richText": "滿$10享<highlight>2</highlight>折",
    "orderTitle": "立即選購",
    "text": "滿$10享2折"
  }
 */
export class DiscountBarView extends ContentSuperItem {
  render() {
    const { data } = this.props;
    const discountData = data?.discountBar || {};

    const bgColor = discountData?.bgColor;
    const orderBgColor = discountData?.orderBgColor;
    const orderTagIcon = discountData?.orderTagIcon;
    const richText = discountData?.richText;
    const orderTitle = discountData?.orderTitle;

    const richTextContents: any = highlightListForText(richText).map((item) => ({
      type: 'text',
      text: item.text,
      fontSize: item.highlight ? 20 : 12,
      color: orderBgColor,
      fontFamily: 'KeeTa-Bold',
      fontWeight: 'bold'
    }));

    return (
      <view className="container">
        <view className="content-area" style={{ backgroundColor: bgColor }}>
          {/* 左边区 */}
          <view className="left-area">
            {/* 富文本 */}
            <view className="left-text-wrapper">
              <RichText className="left-text" content={richTextContents} />
            </view>
          </view>

          {/* 右边区 */}
          <view className="right-area">
            <view className="right-area-container">
              {/* 高亮文字 */}
              <view className="right-text-wrapper" style={{ backgroundColor: orderBgColor }}>
                <text className="right-text" content={orderTitle} />
              </view>
              {/* 箭头图 */}
              <view className="right-icon-image-wrapper">
                <image autoRTL className="right-icon-image" src={orderTagIcon} />
              </view>
            </view>
          </view>
        </view>
      </view>
    );
  }
}
